import React from "react";
import AnonymousPage from "@/models/base/AnonymousPage";
import {
    Button,
    ButtonType,
    EmailInput, FileInput,
    Form, IStringInputModel,
    PageContainer,
    PageHeader, TextAreaInput,
    TextInput
} from "@reapptor-apps/reapptor-react-components";
import ReactMarkdown from "react-markdown";
import styles from "./OccupationalHealthOfferForm.module.scss";
import Localizer from "@/localization/Localizer";
import {JobsData, JobsResponse} from "@/models/cms/JobsResponse";
import {BasePageParameters, PageRouteProvider} from "@reapptor-apps/reapptor-react-common";
import PageDefinitions from "@/providers/PageDefinitions";
import {FileModel} from "@reapptor-apps/reapptor-toolkit";
import Dictionary from "typescript-collections/dist/lib/Dictionary";

export interface IOccupationalHealthOfferFormParams extends BasePageParameters {}

interface IOccupationalHealthOfferFormState {
    data: JobsData | null;
}

export default class OccupationalHealthOfferForm extends AnonymousPage {
    state: IOccupationalHealthOfferFormState = {
        data: null
    }

    public email: IStringInputModel = {value: ""};
    public phone: IStringInputModel = {value: ""};
    public name: IStringInputModel = {value: ""};
    public companyName: IStringInputModel = {value: ""};
    public message: IStringInputModel = {value: ""};
    
    public formRef: React.RefObject<Form> = React.createRef();

    async initializeAsync(): Promise<void> {
        await super.initializeAsync();
        window.scrollTo(0, 0);
    }

    public async handleSubmitAsync(data: Dictionary<string, any>): Promise<void> {
        const occupationalHealthOfferRequest = {} as any;
        data.keys().map((key) => {
            return (occupationalHealthOfferRequest[key] = data.getValue(key));
        });

        await this.postAsync("api/ContactSupport/OccupationalHealthOffer", occupationalHealthOfferRequest);
    }

    public render(): React.ReactNode {

        return (
            <PageContainer fullWidth className={styles.pageContainer}>
                <PageHeader className={styles.pageHeader} title={Localizer.occupationalHealthOfferFormTitle}/>
                <div className={styles.pageContent}>
                    <div className={styles.fluidContent}>
                        <div className={styles.box}>
                            <h2 className={styles.contactSupportHeader}>{Localizer.occupationalHealthOfferFormFormTitle}</h2>
                            <Form id="form" onSubmit={async (_, data) => await this.handleSubmitAsync(data)} ref={this.formRef}>
                                <TextInput id="name" required label={Localizer.formInputName} model={this.name}/>
                                <EmailInput
                                    id="email"
                                    label={Localizer.formInputEmail}
                                    model={this.email}
                                    required
                                    readonly={!!this.email.value}
                                />
                                <TextInput id="phone" required label={Localizer.formInputPhone} model={this.phone}/>
                                <TextInput id="companyName" label={Localizer.formInputCompanyName} model={this.companyName}/>
                                <TextAreaInput id="message" label={Localizer.formInputMessage} model={this.message} rows={6}/>

                                <Button submit className={styles.button} type={ButtonType.Orange} label={Localizer.formSend}/>
                            </Form>
                        </div>
                    </div>
                </div>
            </PageContainer>
        );
    }
}